import {Component} from 'react';
import h from 'react-hyperscript';
import './AccordionItemHeader.scss';
import {h4, subhead} from 'Components/Typography/Typography';
import Button from 'Components/Buttons/Buttons';
import ProgressBar from 'Components/DataViz/ProgressBar/ProgressBar';
import Image from 'Components/Image/Image';
import Benchmarking from 'Components/Benchmarking/Benchmarking';
import {
  setZeroIfInvalidNumber,
  handleButtonKeyEvents,
  getPercentageDifference} from 'Src/utils/utils';

class AccordionItemHeader extends Component {
  constructor(props) {
    super(props);
    this.state = {
      barBackgroundColor: 'transparent',
    };
  }

  componentDidMount() {
    this.checkBackgroundColor();
  }

  componentDidUpdate(prevProps) {
    if (this.props.isExpanded !== prevProps.isExpanded) {
      this.checkBackgroundColor();
    }
  }

  checkBackgroundColor() {
    if (this.props.isExpanded) {
      this.setBackgroundColor('e8eaed');
    } else {
      this.setBackgroundColor('transparent');
    }
  }

  setBackgroundColor(value) {
    this.setState({
      barBackgroundColor: value,
    });
  }

  render() {
    const value = setZeroIfInvalidNumber(this.props.progress);

    const progressComponents = [
      h(ProgressBar, {
        key: `${this.props.id}__key`,
        id: `${this.props.id}`,
        value: value,
        height: 10,
        width: 150,
        color: '#1a73e8',
        background: 'transparent',
      }, null),
      h(h4, {
        className: 'padding-left--md',
      }, `${Math.floor(value * 100)}%`),
    ];

    const valuePrev = this.props.progressPrev;

    if (this.props.progressPrev && !isNaN(valuePrev)) {
      const change = getPercentageDifference(
          value,
          setZeroIfInvalidNumber(valuePrev)
      );

      progressComponents.push(
          h(Benchmarking, {
            change,
            className: 'padding-left--micro padding-bottom--micro-2',
          })
      );
    }

    return (
      h('div', {
        className: 'flex--space-between accordion__item__title',
        dataaccordion: this.props.index,
      }, [
        h('div', {
          className: 'click-overlay',
          onClick: this.props.handleAccordionToggle,
        }),
        h(subhead, {
          key: `accordion-graph-title__key`,
          className: 'flex',
        }, [
          h(Image, {
            key: `${this.props.id}--icon`,
            src: this.props.icon,
            className: 'padding-right--micro accordion__header__icon',
          }, null),
          this.props.title,
          this.props.hasError ? null : h('span', {
            className: 'top-priority__flag text--blue',
          }, 'Top Priority'),
        ]),

        this.props.hasError ? null : h('div', {
          className: 'flex--space-between--all accordion__header__progress-bar',
        }, progressComponents),

        h(Button, {
          key: 'expand-all-button__key',
          type: 'inline',
          to: '#',
          onClick: (e) => {
            e.preventDefault();
          },
          onKeyUp: (e) => handleButtonKeyEvents(e,
              this.props.handleAccordionToggle
          ),
        }, h('span', {
          key: 'survey-messaging-cta-link',
          className: 'material-icons',
        }, 'keyboard_arrow_down')),
      ])
    );
  }
}

export default AccordionItemHeader;
